"use strict";

const body = document.querySelector('body');

// Sizzle reel toggle

// const sizzleVideoOuter = document.querySelector('.sizzle-video-outer');
// const sizzleVideoPlay = document.querySelector('.sizzle-video__play');
// const sizzleVideoTitle = document.querySelector('.sizzle-video__title');
// const sizzleVideoMiniPlay = document.querySelector('.sizzle-video__mini-play');
// const sizzleVideoPause = document.querySelector('.sizzle-video__pause');
// const sizzleVideo = document.querySelector('.sizzle-video');
// const sizzleVideoMedia = document.querySelector('.sizzle-video__media');

// if(sizzleVideoOuter) {
  
//   sizzleVideoPlay.addEventListener('click', function(){
//     sizzleVideoOuter.classList.add('video-is-playing');
//     sizzleVideoTitle.classList.add('is-hidden');
//     sizzleVideoMedia.play();
//   });

//   sizzleVideoPause.addEventListener('click', function(){
//     sizzleVideoOuter.classList.remove('video-is-playing');
//     sizzleVideoOuter.classList.add('video-is-paused');
//     sizzleVideoMedia.pause();
//   })

//   sizzleVideoMiniPlay.addEventListener('click', function(){
//     sizzleVideoOuter.classList.remove('video-is-paused');
//     sizzleVideoOuter.classList.add('video-is-playing');
//     sizzleVideoMedia.play();
//   });

// }

// Service list toggles

const serviceToggles = document.querySelectorAll('.service-toggle');
const serviceInfoPanels = document.querySelectorAll('.service-info');

serviceToggles.forEach(function(serviceToggle){
  serviceToggle.addEventListener('click', function(){
      // tabTriggers in this instance is where the dash-style is converted to camelCase - so data-tab-trigger converts to tabTriggers
      const currentToggleData = document.querySelector('.service-info[data-service-content="' + this.dataset.serviceToggle + '"]');

      // remove classess
      document.querySelector('.service-info.is-visible').classList.remove('is-visible');
      document.querySelector('.service-toggle.is-selected').classList.remove('is-selected');
      // add classes
      currentToggleData.classList.add('is-visible');
      this.classList.add('is-selected');
  });
});


// FILTERING

const articleGridList = document.querySelector('.feed--paginated');
const workGridList = document.querySelector('.feed--filtered');
const targetSelector = '.mix';

function getSelectorFromHash() {
  var hash = window.location.hash.replace(/^#/g, "");

  var selector = hash ? "." + hash : targetSelector;

  return selector;
}

function setHash(state) {
  var selector = state.activeFilter.selector;
  var newHash = "#" + selector.replace(/^./g, "");

  if (selector === targetSelector && window.location.hash) {
    // Equivalent to filter "all", remove the hash

    history.pushState(null, document.title, window.location.pathname); // or history.replaceState()
  } else if (
    newHash !== window.location.hash &&
    selector !== targetSelector
  ) {
    // Change the hash

    history.pushState(
      null,
      document.title,
      window.location.pathname + newHash
    ); // or history.replaceState()
  }
}

if (articleGridList) {
  const mixer = mixitup(articleGridList, {
    animation: {
      enable: false,
      animateResizeContainer: false
    },
    pagination: {
      limit: 12,
      hidePageListIfSinglePage: true,
      loop: true
    },
    selectors: {
      pageList: '.pagination',
      target: targetSelector
    },
    load: {
      filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
    },
    callbacks: {
      onMixEnd: setHash // Call the setHash() method at the end of each operation
    },
    templates: {
      pagerPrev:
        '<button type="button" class="${classNames} pg-prev" data-page="prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>arrow</title><polygon points="73.23 23.23 69.7 26.77 90.43 47.5 0 47.5 0 52.5 90.43 52.5 69.7 73.23 73.23 76.77 100 50 73.23 23.23"/></svg></button>',
      pagerNext:
        '<button type="button" class="${classNames} pg-next" data-page="next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><title>arrow</title><polygon points="73.23 23.23 69.7 26.77 90.43 47.5 0 47.5 0 52.5 90.43 52.5 69.7 73.23 73.23 76.77 100 50 73.23 23.23"/></svg></button>',
      pager:
        '<button type="button" class="${classNames} pg-number" data-page="${pageNumber}">${pageNumber}</button>'
    }
  });
}

if (workGridList) {
  const mixer = mixitup(workGridList, {
    animation: {
      enable: false,
      animateResizeContainer: false
    },
    load: {
      filter: getSelectorFromHash() // Ensure that the mixer's initial filter matches the URL on startup
    },
    callbacks: {
      onMixEnd: setHash // Call the setHash() method at the end of each operation
    },
  });
}

window.onhashchange = function() {
  var selector = getSelectorFromHash();

  if (selector === mixer.getState().activeFilter.selector) return; // no change

  mixer.filter(selector);
};

// Check for flexbox gap support

function checkFlexGap() {
// create flex container with row-gap set
  const flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  // create two, elements inside it
  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  // append to the DOM (needed to obtain scrollHeight)
  document.body.appendChild(flex);
  const isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
  flex.parentNode.removeChild(flex);

  return isSupported;
  }

if (checkFlexGap()) {
  body.classList.add("flexbox-gap");
} else {
  body.classList.add("no-flexbox-gap");
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}